"use client";

import { Confetti } from "@phosphor-icons/react/dist/ssr";
import { Section } from "@/common/components-2/section";
import { isNil } from "@/common/helpers/lang";
import type { HranoPage } from "@/payload-types";

export function PromoSection(props: HranoPage["ps"]) {
  if (isNil(props) || isNil(props.text)) return null;

  return (
    <Section
      classes={{
        section: "bg-dodger-blue-700 py-4 text-primary-foreground",
        container: "flex-row items-center justify-center gap-6",
      }}
    >
      <Confetti size={60} />
      <p className="font-semibold text-2xl">{props.text}</p>
      <Confetti size={60} />
    </Section>
  );
}
